module.exports = __webpack_public_path__ + "static/media/email.89a5486b.svg";